import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import DisplayerIcon from './DisplayerIcon';
import './BubbleDisplayer.css';
import WarningInsideBubble from '../WarningContent/WarningInsideBubble';
import { Desktop, Mobile } from '../../MediaQuery';

/* Constants */
const tooltipId = 'eyewear-bubble';
const reactTooltipClassName = 'ReactTooltipStyleOverride';
const reactTooltipClassNameDesktop = `${reactTooltipClassName} desktop`;
const reactTooltipClassNameMobile = `${reactTooltipClassName} mobile`;

/* Components */
const DesktopWarningWrapper = styled.div`
  height: 175px;
  width: 230px;
`;
const MobileWarningWrapper = styled.div`
  height: 200px;
  width: 200px;
`;

const BubbleDisplayer: React.FC = () => (
  <>
    <Desktop>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a data-cy="eyewear-warning-tooltip-activator" data-for={tooltipId} data-tip="">
        <DisplayerIcon />
      </a>
      <ReactTooltip
        border
        className={reactTooltipClassNameDesktop}
        delayHide={200}
        effect="solid"
        id={tooltipId}
        place="right"
      >
        <DesktopWarningWrapper>
          <WarningInsideBubble />
        </DesktopWarningWrapper>
      </ReactTooltip>
    </Desktop>

    <Mobile>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a data-cy="eyewear-warning-tooltip-activator" data-event="click" data-for={tooltipId} data-tip="">
        <DisplayerIcon />
      </a>
      <ReactTooltip
        border
        className={reactTooltipClassNameMobile}
        effect="solid"
        globalEventOff="click"
        id={tooltipId}
        place="top"
      >
        <MobileWarningWrapper>
          <WarningInsideBubble />
        </MobileWarningWrapper>
      </ReactTooltip>
    </Mobile>
  </>
);

export default BubbleDisplayer;
